<lib-auth-container
  headerTXT="{{ 'auth.mail.title' | translate }}"
  btnLabel="{{ 'auth.mail.button_action' | translate }}"
  (btnClick)="validateCode(codeControl.value + '')"
  [(loading)]="loading"
>
  <form #codeProcess>
    <label for="username" class="font-normal px-1 !text-gray-500" hlmLabel>{{
      'auth.mail.label' | translate
    }}</label>
    <input
      id="username"
      class="w-full !py-2"
      hlmInput
      hp
      authCode
      maxlength="7"
      [formControl]="codeControl"
      required
      [placeholder]="'auth.mail.placeholder' | translate"
    />
    @if ( hasError("required") ) {
    <p class="text-red-500 px-2 text-sm pt-1">
      {{ 'auth.mail.required_code' | translate }}
    </p>
    } @if ( hasError("email") ) {
    <p class="text-red-500 px-2 text-sm pt-1">
      {{ 'auth.mail.invalid_code' | translate }}
    </p>
    }
  </form>
</lib-auth-container>
